import { render, staticRenderFns } from "./PracticeTopicTreeView.vue?vue&type=template&id=d81262ca&scoped=true&"
import script from "./PracticeTopicTreeView.vue?vue&type=script&lang=js&"
export * from "./PracticeTopicTreeView.vue?vue&type=script&lang=js&"
import style0 from "./PracticeTopicTreeView.vue?vue&type=style&index=0&id=d81262ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81262ca",
  null
  
)

export default component.exports